module.exports = __webpack_public_path__ + "img/008-construction.3e3d54d8.png";